import { createFileRoute } from '@tanstack/react-router';
import SEO from 'components/Seo/Seo';
import { useSelector } from 'react-redux';
import { RootState } from 'store/reducer';
import { UpdatePasswordComponent } from './components/UpdatePassword';
import messages from './messages';

export const Route = createFileRoute(
  '/_authenticated/settings/update-password',
)({
  component: UpdatePassword,
});

function UpdatePassword() {
  const { language } = useSelector(
    (rootState: RootState) => rootState.language,
  );

  const updatePasswordMessages = messages[language];

  return (
    <>
      <SEO
        title={updatePasswordMessages.title}
        description={updatePasswordMessages.description}
        keywords={updatePasswordMessages.keywords}
        page="settings/two-factor"
      />
      <UpdatePasswordComponent />
    </>
  );
}

export default UpdatePassword;
